export const table_titles = [
	{ name: "#", size: 5, order: "" },
	{ name: "Nombre", size: 20, order: "name" },
	{ name: "Paso 1", size: 15, order: "specie_name" },
	{ name: "Cliente", size: 20, order: "customer_name", only_admin: true },
	{ name: "Acción", size: 10, order: "" },
];

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};

export const filters = {
	filter_customer: "",
	filter_estate: "",
	filter_category: "",
	filter_specie: "",
};
